import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import header_logo from '../../assets/images/Logo.svg';
import header_1 from '../../assets/images/svg/header/Insta.svg';
import header_2 from '../../assets/images/svg/header/Fb.svg';
import header_3 from '../../assets/images/svg/header/Twiter.svg';
import header_4 from '../../assets/images/svg/header/Pintrest.svg';

const Header4 = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [isScrollTopActive, setIsScrollTopActive] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrollTopActive(window.scrollY > 100);
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        document.body.classList.toggle("mobile-menu-open", !isMenuOpen);
    };
    const toggleOpenDropdown = (index) => {
        setOpenDropdown(openDropdown === index ? null : index);
    };

    const toggleDropdown = (dropdownName) => {
        setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <>

            <header className="main-header header-four" id="no-sticky-header">
                <nav className={`main-menu ${isExpanded ? "expanded" : ""}`}>
                    <div className="main-menu-logo">
                        <Link to="/">
                            <img src={header_logo} alt="header-logo" />
                        </Link>
                    </div>
                    <div className="main-menu-inner">
                    <ul className="main-menu-list">
                    <li
                        className={`menu-item-children ${activeDropdown === "home" ? "active" : ""
                            }`}
                    >
                        <Link to="#" onClick={() => toggleDropdown("home")}>Home  <i className=" icon fa-solid fa-chevron-down" style={{
                            position: 'relative',
                            right: '-115px',
                        }} /></Link>
                        {activeDropdown === "home" && (
                            <ul>
                                <li><Link to="/">Home One</Link></li>
                                <li><Link to="/HomeTwo">Home Two</Link></li>
                                <li><Link to="/HomeThree">Home Three</Link></li>
                                <li><Link to="/HomeFour">Home Four</Link></li>
                                <li><Link to="/HomeFive">Home Five</Link></li>
                            </ul>
                        )}
                    </li>
                    <li
                        className={`menu-item-children ${activeDropdown === "pages" ? "active" : ""
                            }`}
                    >
                        <Link to="#" onClick={() => toggleDropdown("pages")}>Pages <i className="fa-solid fa-chevron-down" style={{
                            position: 'relative',
                            right: '-115px',
                        }} /></Link>
                        {activeDropdown === "pages" && (
                            <ul>
                                <li><Link to="/Aboutus">About Us</Link></li>
                                <li><Link to="/Careers">Careers</Link></li>
                                <li><Link to="/Team">Meet The Team</Link></li>
                                <li><Link to="/Testimonial">Testimonial</Link></li>
                                <li><Link to="/Pricing">Pricing</Link></li>
                            </ul>
                        )}
                    </li>
                    <li
                        className={`menu-item-children ${activeDropdown === "services" ? "active" : ""}`}
                    >
                        <Link to="#" onClick={() => toggleDropdown("services")}>Services <i className="fa-solid fa-chevron-down" style={{
                            position: 'relative',
                            right: '-96px',
                        }} /></Link>
                        {activeDropdown === "services" && (
                            <ul>
                                <li><Link to="/Services">Services</Link></li>
                                <li><Link to="/ServiceDetails">Services Details</Link></li>
                            </ul>
                        )}
                    </li>
                    <li
                        className={`menu-item-children ${activeDropdown === "portfolio" ? "active" : ""
                            }`}
                    >
                        <Link to="#" onClick={() => toggleDropdown("portfolio")}>Portfolio <i className="fa-solid fa-chevron-down" style={{
                            position: 'relative',
                            right: '-97px',
                        }} /></Link>
                        {activeDropdown === "portfolio" && (
                            <ul>
                                <li><Link to="/Portfolio">Portfolio</Link></li>
                                <li><Link to="/Details">Portfolio Details</Link></li>
                            </ul>
                        )}
                    </li>
                    <li
                        className={`menu-item-children ${activeDropdown === "blog" ? "active" : ""
                            }`}
                    >
                        <Link to="#" onClick={() => toggleDropdown("blog")}>Blog <i className="fa-solid fa-chevron-down" style={{
                            position: 'relative',
                            right: '-124px',
                        }} /></Link>
                        {activeDropdown === "blog" && (
                            <ul>
                                <li><Link to="/Blog">Blog Standard</Link></li>
                                <li><Link to="/BlogDetails">Blog Details</Link></li>
                            </ul>
                        )}
                    </li>
                    <li
                        className={`menu-item-children ${activeDropdown === "shop" ? "active" : ""
                            }`}
                    >
                        <Link to="#" onClick={() => toggleDropdown("shop")}>Shop  <i className="fa-solid fa-chevron-down" style={{
                            position: 'relative',
                            right: '-121px',
                        }} /></Link>
                        {activeDropdown === "shop" && (
                            <ul>
                                <li><Link to="/Shop">Shop</Link></li>
                                <li><Link to="/ProdectDetails">Product Details</Link></li>
                                <li><Link to="/Cart">Cart</Link></li>
                                <li><Link to="/Checkout">Checkout</Link></li>
                            </ul>
                        )}
                    </li>
                    <li>
                        <Link to="/Contact">Contact Us</Link>
                    </li>
                </ul>
                        <div className="header-menu-collaps" onClick={toggleMenu}>
                            <span className="line-1" />
                            <span className="line-2" />
                            <span className="line-3" />
                        </div>
                        <div className={`mobile-nav-wrapper ${isMenuOpen ? "expanded" : ""}`}>

                            <div className="mobile-nav-overlay" onClick={toggleMenu}></div>
                            <div className="mobile-nav-content">
                                <button className="mobile-nav-close" onClick={toggleMenu} style={{ background: "none", fontSize: 50, border: "none", position: "fixed", top: 10, color: "#fff" }} >
                                    ×
                                </button>
                                <div className="logo-box">
                                    <Link to="/">
                                        <img width="150" src={header_logo} alt="logo" />
                                    </Link>
                                </div>
                                <div className="mobile-nav-container">
                                    <ul className="mobile-menu-list">

                                        <li className={`menu-item-has-children ${openDropdown === 1 ? "dropdown-open" : ""}`}>
                                            <Link to="#" onClick={() => toggleOpenDropdown(1)}>Home <i className="fa-solid fa-chevron-down" /></Link>
                                            {openDropdown === 1 && (
                                                <ul>
                                                    <li><Link to="/">Home-1</Link></li>
                                                    <li><Link to="/HomeTwo">Home-2</Link></li>
                                                    <li><Link to="/HomeThree">Home-3</Link></li>
                                                    <li><Link to="/HomeFour">Home-4</Link></li>
                                                    <li><Link to="/HomeFive">Home-5</Link></li>
                                                </ul>
                                            )}
                                        </li>
                                        <li className={`menu-item-has-children ${openDropdown === 2 ? "dropdown-open" : ""}`}>
                                            <Link to="#" onClick={() => toggleOpenDropdown(2)}>Pages <i className="fa-solid fa-chevron-down" /></Link>
                                            {openDropdown === 2 && (
                                                <ul>
                                                    <li><Link to="/Aboutus">About Us</Link></li>
                                                    <li><Link to="/Careers">Careers</Link></li>
                                                    <li><Link to="/Team">Meet The Team</Link></li>
                                                    <li><Link to="/Testimonial">Testimonial</Link></li>
                                                    <li><Link to="/Pricing">Pricing</Link></li>
                                                </ul>
                                            )}
                                        </li>
                                        <li className={`menu-item-has-children ${openDropdown === 3 ? "dropdown-open" : ""}`}>
                                            <Link to="#" onClick={() => toggleOpenDropdown(3)}>Services <i className="fa-solid fa-chevron-down" /></Link>
                                            {openDropdown === 3 && (
                                                <ul>
                                                    <li><Link to="/Services">Services</Link></li>
                                                    <li><Link to="/ServiceDetails">Service Details </Link></li>
                                                </ul>
                                            )}
                                        </li>
                                        <li className={`menu-item-has-children ${openDropdown === 4 ? "dropdown-open" : ""}`}>
                                            <Link to="#" onClick={() => toggleOpenDropdown(4)}>Portfolio<i className="fa-solid fa-chevron-down" /></Link>
                                            {openDropdown === 4 && (
                                                <ul>
                                                    <li><Link to="/Portfolio">Portfolio</Link></li>
                                                    <li><Link to="/Details">Portfolio Details</Link></li>
                                                </ul>
                                            )}
                                        </li>
                                        <li className={`menu-item-has-children ${openDropdown === 5 ? "dropdown-open" : ""}`}>
                                            <Link to="#" onClick={() => toggleOpenDropdown(5)}>Blog <i className="fa-solid fa-chevron-down" /></Link>
                                            {openDropdown === 5 && (
                                                <ul>
                                                    <li><Link to="/Blog">Blog Standard</Link></li>
                                                    <li><Link to="/BlogDetails">Blog Details</Link></li>
                                                </ul>
                                            )}
                                        </li>
                                        <li className={`menu-item-has-children ${openDropdown === 6 ? "dropdown-open" : ""}`}>
                                            <Link to="#" onClick={() => toggleOpenDropdown(6)}>Shop <i className="fa-solid fa-chevron-down" /></Link>
                                            {openDropdown === 6 && (
                                                <ul>
                                                    <li><Link to="/Shop">Shop</Link></li>
                                                    <li><Link to="/ProductDetails">Product Details</Link></li>
                                                    <li><Link to="/Cart">Cart</Link></li>
                                                    <li><Link to="/Checkout">Checkout</Link></li>
                                                </ul>
                                            )}
                                        </li>
                                        <li>
                                            <Link to="/Contact">Contact Us</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="main-menu-right">
                        <ul className="header-social-media">
                            <li><Link to="https://www.instagram.com/"><img src={header_1} alt="icon" /></Link></li>
                            <li><Link to="https://www.facebook.com/"><img src={header_2} alt="icon" /></Link></li>
                            <li><Link to="https://x.com/"><img src={header_3} alt="icon" /></Link></li>
                            <li><Link to="https://www.pinterest.com/"><img src={header_4} alt="icon" /></Link></li>
                        </ul>
                    </div>
                </nav>
            </header>

            <div
                style={{
                    position: "fixed",
                    right: "26px",
                    bottom: "35px",
                    height: "50px",
                    width: "50px",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    boxShadow:
                        "0 4px 6px rgba(0, 0, 0, 0.1), inset 0 0 0 2px var(--uniqo-primary)",
                    zIndex: 9999,
                    backgroundColor: "#fff",
                    opacity: isScrollTopActive ? 1 : 0,
                    visibility: isScrollTopActive ? "visible" : "hidden",
                    transform: isScrollTopActive ? "translateY(0)" : "translateY(15px)",
                    transition: "all 200ms ease-in-out",
                }}
                onClick={scrollToTop}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="var(--uniqo-secondary)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <polyline points="18 15 12 9 6 15" />
                </svg>
            </div>
        </>
    );
};

export default Header4;
